import React, { useState, useEffect, useContext, Suspense } from "react";
import { connect } from "react-redux";
import ServerMasterTable from "../../components/common/ServerMasterTable";
import { Form, Formik } from "formik";
import { Button, FormGroup, Row } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import {
  FormikDatePicker,
  FormikReactSelect, // Added Import
} from "../../containers/form-validations/FormikFields";
import FormLoader from "../../components/loader/FormLoader";
import { viewInvoice } from "../../redux/admin/Report/action";
import { getDspUser1 } from "../../redux/admin/SimInvoice/action";
import { downloadInvoice, updateInvoice, clearInvoicePreview } from "../../redux/admin/Report/action";
import { apiDate, getDate, getDate1, getPriceFormatter } from "../../constants/defaultValues";
import IntlMessages from "../../utils/IntlMessages";
import { LayoutContext } from "../../layouts/UserLayout";
import ConfirmModal from "../../components/notifcationmodal/ConfirmModal";
import { hasPermission } from "../../utils/UserDetails";

// --- COMPONENT: Editable Date Cell ---
const EditableDateCell = ({ initialDate, currentInvoiceNumber, invoiceId, onUpdate, menuId }) => {
  const [isEditing, setIsEditing] = useState(false);

  const formatDateForInput = (dateVal) => {
    if (!dateVal) return "";
    const date = new Date(dateVal);
    return date.toISOString().split('T')[0];
  };

  const [editValue, setEditValue] = useState(formatDateForInput(initialDate));
  const maxDate = new Date().toISOString().split("T")[0];

  const handleEditClick = (e) => {
    e.stopPropagation();
    setEditValue(formatDateForInput(initialDate));
    setIsEditing(true);
  };

  const handleSave = (e) => {
    e.stopPropagation();
    if (editValue) {
      onUpdate(invoiceId, currentInvoiceNumber, editValue);
    }
    setIsEditing(false);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    setIsEditing(false);
    setEditValue(formatDateForInput(initialDate));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSave(e);
    else if (e.key === "Escape") handleCancel(e);
  };

  if (isEditing) {
    return (
      <div className="d-flex align-items-center justify-content-center" onClick={(e) => e.stopPropagation()}>
        <input
          type="date"
          className="form-control form-control-sm mx-1"
          style={{ width: "130px", display: "inline-block" }}
          value={editValue}
          max={maxDate}
          onChange={(e) => setEditValue(e.target.value)}
          onKeyDown={handleKeyDown}
          autoFocus
          onClick={(e) => e.stopPropagation()}
        />
        <span
          style={{ color: "#28a745", cursor: "pointer", fontSize: "18px", fontWeight: "bold", marginRight: "8px" }}
          onClick={handleSave}
        >✓</span>
        <span
          style={{ color: "#dc3545", cursor: "pointer", fontSize: "18px", fontWeight: "bold" }}
          onClick={handleCancel}
        >✕</span>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center justify-content-center" onClick={(e) => e.stopPropagation()}>
      <span>{getDate1(initialDate)}</span>
      <span
        style={{ marginLeft: "8px", cursor: "pointer", color: "#007bff", fontSize: "14px" }}
        onClick={handleEditClick}
      >✎</span>
    </div>
  );
};

// --- COMPONENT: Editable Invoice Cell ---
const EditableInvoiceCell = ({ invoiceNumber, currentInvoiceDate, invoiceId, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState("");

  const parseInvoiceNumber = (invNum) => {
    if (!invNum) return { prefix: "VT-2025-", number: "" };
    const match = invNum.match(/^(VT-\d{4}-)(\d+)$/);
    if (match) return { prefix: match[1], number: match[2] };
    return { prefix: "VT-2025-", number: "" };
  };

  const { prefix, number } = parseInvoiceNumber(invoiceNumber);

  const handleEditClick = (e) => {
    e.stopPropagation();
    setEditValue(number);
    setIsEditing(true);
  };

  const handleSave = (e) => {
    e.stopPropagation();
    if (editValue) {
      const newInvoiceNumber = `${prefix}${editValue}`;
      onUpdate(invoiceId, newInvoiceNumber, currentInvoiceDate);
    }
    setIsEditing(false);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    setIsEditing(false);
    setEditValue(number);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSave(e);
    else if (e.key === "Escape") handleCancel(e);
  };

  if (isEditing) {
    return (
      <div className="d-flex align-items-center justify-content-center" onClick={(e) => e.stopPropagation()}>
        <span style={{ fontWeight: "500", color: "#666" }}>{prefix}</span>
        <input
          type="text"
          className="form-control form-control-sm mx-1"
          style={{ width: "80px", display: "inline-block" }}
          value={editValue}
          onChange={(e) => setEditValue(e.target.value.replace(/\D/g, ""))}
          onKeyDown={handleKeyDown}
          autoFocus
          onClick={(e) => e.stopPropagation()}
        />
        <span
          style={{ color: "#28a745", cursor: "pointer", fontSize: "18px", fontWeight: "bold", marginRight: "8px" }}
          onClick={handleSave}
        >✓</span>
        <span
          style={{ color: "#dc3545", cursor: "pointer", fontSize: "18px", fontWeight: "bold" }}
          onClick={handleCancel}
        >✕</span>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center justify-content-center" onClick={(e) => e.stopPropagation()}>
      <span>{invoiceNumber || `${prefix}0`}</span>
      <span
        style={{ marginLeft: "8px", cursor: "pointer", color: "#007bff", fontSize: "14px" }}
        onClick={handleEditClick}
      >✎</span>
    </div>
  );
};

// --- MAIN COMPONENT: CustomerInvoiceReport ---
const CustomerInvoiceReport = ({
  getDspUser1,
  viewInvoice,
  invoiceListData,
  customerslist,
  voucherSaleData,
  downloadInvoice,
  pdfData,
  invoiceData,
  updateInvoice,
  invoiceUpdateData,
  menuId,
  clearInvoicePreview
}) => {

  const { setPageTitle } = useContext(LayoutContext);
  const [currentDate] = useState(apiDate(new Date()));
  const [selectedRows, setSelectedRows] = useState([]);

  // 1. Define Options
  const typeOptions = [
    { value: "", label: "All" },
    { value: "sim", label: "Sim" },
    { value: "voucher", label: "Voucher" },
  ];

  // 2. Initialize Data
  const initialData = {
    fromDate: currentDate ? new Date(currentDate) : new Date(),
    toDate: currentDate ? new Date(currentDate) : new Date(),
    type: typeOptions[0], // Default to "All"
  };

  const [initialValues, setIntialValues] = useState(initialData);

  const [manageDetailsParam, setManageDetailsParam] = useState({
    limit: 50,
    offset: 0,
    searchTerm: "",
    orderBy: "invoicedate",
    format: "DESC",
    fromDate: currentDate ? currentDate : new Date(),
    toDate: currentDate ? currentDate : new Date(),
    type: "" // Add type parameter
  });

  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  const [show, setShow] = useState(false);
  const [loadingDownloadIds, setLoadingDownloadIds] = useState([]);
  const [isBulkLoading, setIsBulkLoading] = useState(false);

  // Modal Data
  const [notificationData, setNotificationData] = useState({
    isSuccess: 2,
    header: "Are you sure to download invoice?",
  });

  const [isPreviewRequested, setIsPreviewRequested] = useState(false);


  useEffect(() => {
    setPageTitle(<IntlMessages id={menuId} />);
    return () => setPageTitle("");
  }, [setPageTitle]);

  useEffect(() => {
    getDspUser1();
  }, [getDspUser1]);

  useEffect(() => {
    viewInvoice(manageDetailsParam);
  }, [manageDetailsParam]);

  useEffect(() => {
    setSelectedRows([]);
  }, [invoiceListData]);

  useEffect(() => {
    if (
      isPreviewRequested &&
      pdfData &&
      pdfData instanceof Blob
    ) {
      const url = URL.createObjectURL(pdfData);
      window.open(url, "_blank");

      setIsLoadingPreview(false);
      setIsPreviewRequested(false);
    }
  }, [pdfData, isPreviewRequested]);


  const toggleModal = () => setShow(!show);

  const deleteData = async () => {
    setShow(false);
    setNotificationData({ ...notificationData, isLoading: 0 });
    
    // Check if it's a bulk download (array of invoice IDs) or single download
    if (notificationData.data?.invoiceids && Array.isArray(notificationData.data.invoiceids)) {
      // Bulk download - send all selected invoice IDs in a single API call
      setIsBulkLoading(true);
      try {
        await downloadInvoice({ invoiceid: notificationData.data.invoiceids.join(","), isPdf: 1 });
      } catch (err) {
        console.error(err);
      } finally {
        setIsBulkLoading(false);
      }
    } else if (notificationData.data?.invoiceid) {
      // Single download
      const singleId = notificationData.data.invoiceid;
      setLoadingDownloadIds((prev) => [...prev, singleId]);
      try {
        await downloadInvoice(notificationData.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingDownloadIds((prev) => prev.filter((id) => id !== singleId));
      }
    }
  };


  const handleInvoiceDownloadRequest = (props) => {
    setNotificationData({
      ...notificationData,
      header: "Are you sure to download invoice?",
      isLoading: 0,
      data: { invoiceid: props?.row?.original?.invoiceid, isPdf: 1, invoicenumber: props?.row?.original?.invoicenumber },
    });
    setShow(true);
  };

  const handleInvoicePreview = (props) => {
    console.log(props?.row?.original)
    setIsLoadingPreview(true);
    setIsPreviewRequested(true);
    clearInvoicePreview();
    downloadInvoice({ invoiceid: props?.row?.original?.invoiceid, isPdf: 1, isPreview: true, invoicenumber: props?.row?.original?.invoicenumber });
  };


  const handleUnifiedUpdate = (invoiceId, newInvoiceNumber, newInvoiceDate, originalData) => {
    const payload = { invoiceid: invoiceId };

    if (
      newInvoiceNumber &&
      newInvoiceNumber !== originalData.invoicenumber
    ) {
      payload.invoicenumber = newInvoiceNumber;
    }

    const formattedNewDate = newInvoiceDate
      ? new Date(newInvoiceDate).toISOString().split("T")[0]
      : null;

    const formattedOldDate = originalData.invoicedate
      ? new Date(originalData.invoicedate).toISOString().split("T")[0]
      : null;

    if (formattedNewDate && formattedNewDate !== formattedOldDate) {
      payload.invoicedate = formattedNewDate;
    }

    if (Object.keys(payload).length === 1) {
      return;
    }

    updateInvoiceData(payload);
  };


  const updateInvoiceData = (data) => {
    let params = {
      data
    }
    updateInvoice(params)
  };

  const handleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleSelectAll = () => {
    const currentPageIds =
      invoiceListData?.map(item => item.invoiceid) || [];

    if (!currentPageIds.length) return;

    const allSelected = currentPageIds.every(id =>
      selectedRows.includes(id)
    );

    if (allSelected) {
      setSelectedRows(prev =>
        prev.filter(id => !currentPageIds.includes(id))
      );
    } else {
      setSelectedRows(prev =>
        Array.from(new Set([...prev, ...currentPageIds]))
      );
    }
  };

  const handleBulkDownload = () => {
    if (selectedRows.length === 0) return;

    // Show confirmation modal for bulk download
    setNotificationData({
      ...notificationData,
      header: `Are you sure to download ${selectedRows.length} invoice${selectedRows.length > 1 ? 's' : ''}?`,
      isLoading: 0,
      data: { invoiceids: selectedRows },
    });
    setShow(true);
  };

  const cols = React.useMemo(() => {
    const columns = [
      {
        Header: <IntlMessages id="serial-no" />,
        accessor: "simvoucherrequestid",
        cellClass: "text-center",
        Cell: (props) => (
          <>{parseInt(props?.row?.id) + 1 + parseInt(manageDetailsParam.offset)}</>
        ),
        sortType: "basic",
      },
      {
        Header: <IntlMessages id="invoicedate" />,
        accessor: "invoicedate",
        cellClass: "text-center",
        disableSortBy: true,
        Cell: (props) => {
          const rowData = props?.row?.original;

          if (hasPermission(menuId, "canWrite")) {
            return (
              <EditableDateCell
                initialDate={props.value}
                currentInvoiceNumber={rowData.invoicenumber}
                invoiceId={rowData.invoiceid}
                onUpdate={(id, num, date) =>
                  handleUnifiedUpdate(id, num, date, rowData)
                }
              />
            );
          }
          return <>{getDate(props.value)}</>;
        },
      },
      {
        Header: <IntlMessages id="invoiceno" />,
        accessor: "invoicenumber",
        cellClass: "text-center",
        disableSortBy: true,
        Cell: (props) => {
          const rowData = props?.row?.original;

          if (hasPermission(menuId, "canWrite")) {
            return (
              <EditableInvoiceCell
                invoiceNumber={props.value}
                currentInvoiceDate={rowData.invoicedate}
                invoiceId={rowData.invoiceid}
                onUpdate={(id, num, date) =>
                  handleUnifiedUpdate(id, num, date, rowData)
                }
              />

            );
          }
          return <>{props.value}</>;
        },
      },
      {
        Header: <IntlMessages id="user-list.companyname" />,
        accessor: "companyname",
        Cell: (props) => <>{`${props.row.original.companyname ?? ''}-${props.row.original.relationshipno ?? ''}`}</>,
        cellClass: "text-center",
        sortType: "basic",
      },
      {
        Header: <IntlMessages id="customer-name" />,
        accessor: "username",
        Cell: (props) => <>{props.value}</>,
        cellClass: "text-center",
        sortType: "basic",
      },
      {
        Header: <IntlMessages id="invoiceamount" />,
        accessor: "invoiceamount",
        Cell: (props) => <>{props.value ? getPriceFormatter(props.value) : "-"}</>,
        cellClass: "text-center",
        sortType: "basic",
      },
        {
      Header: 'Invoice Type',
      accessor: "type",
      Cell: (props) =>
        props.value == 0 ? "SIM" : "VOUCHER",
      cellClass: "text-center",
    },
      {
        Header: "Invoice Preview",
        accessor: "preview_invoice",
        cellClass: "text-center",
        disableSortBy: true,
        Cell: (props) => {
          const invoiceId = props?.row?.original?.invoiceid;

          if (!hasPermission(menuId, "canPrint")) {
            return <>-</>;
          }

          return (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleInvoicePreview(props);
              }}
              style={{
                color: "#007bff",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              View
            </a>
          );
        },
      },
      {
        Header: "Invoice Download",
        accessor: "action_invoice",
        cellClass: "text-center",
        disableSortBy: true,
        Cell: (props) => {
          const invoiceId = props?.row?.original?.invoiceid;

          if (!hasPermission(menuId, "canPrint")) {
            return <>-</>;
          }

          const isLoading = loadingDownloadIds.includes(invoiceId);

          return (
            <Button
              size="sm"
              color="primary"
              onClick={() => handleInvoiceDownloadRequest(props)}
              disabled={isLoading}
            >
              {isLoading ? <FormLoader /> : <IntlMessages id="download" />}
            </Button>
          );
        },
      }
    ];

    /* ---------------- canPrint - Add Select Checkbox ---------------- */
    if (hasPermission(menuId, "canPrint")) {
      columns.unshift({
        Header: <div className="text-center">Select</div>,
        accessor: "select_row",
        disableSortBy: true,
        cellClass: "text-center",
        Cell: (props) => {
          const id = props.row.original.invoiceid;
          return (
            <input
              type="checkbox"
              checked={selectedRows.includes(id)}
              onChange={() => handleSelectRow(id)}
              style={{ cursor: "pointer" }}
            />
          );
        },
      });
    }

    return columns;
  }, [
    menuId,
    manageDetailsParam,
    invoiceListData,
    selectedRows,
    loadingDownloadIds,
  ]);

  return (
    <>
      <div className="p-3">
        <h3></h3>
        <div className="card shadow-sm mt-3">
          <div className="card-body pt-2">
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              onSubmit={(formData, { setSubmitting }) => {
                setIntialValues(formData);
                const params = {
                  limit: 50,
                  offset: 0,
                  searchTerm: "",
                  orderBy: "invoicedate",
                  format: "DESC",
                  fromDate: formData.fromDate ? apiDate(formData.fromDate) : null,
                  toDate: formData.toDate ? apiDate(formData.toDate) : null,
                  // Extract value from Select Object
                  type: formData.type ? formData.type.value : "",
                };
                setManageDetailsParam(params);
                setTimeout(() => setSubmitting(false), 600);
              }}
            >
              {({ setFieldValue, setFieldTouched, values, errors, touched, isSubmitting }) => (
                <Form className="av-tooltip tooltip-label-bottom">
                  <Row className="align-items-start mb-0">
                    <Colxx md="3">
                      <FormGroup className="form-group has-float-label mb-3">
                        <label><IntlMessages id="from" /></label>
                        <FormikDatePicker
                          name="fromDate"
                          value={values.fromDate}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          className="datepicker-styles"
                          placeholder=" "
                        />
                        <div className="text-danger small mt-1">
                          {errors.fromDate && touched.fromDate ? "Date Required" : null}
                        </div>
                      </FormGroup>
                    </Colxx>

                    <Colxx md="3">
                      <FormGroup className="form-group has-float-label mb-3">
                        <label><IntlMessages id="to" /></label>
                        <FormikDatePicker
                          name="toDate"
                          value={values.toDate}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          className="datepicker-styles"
                          placeholder=" "
                        />
                        <div className="text-danger small mt-1">
                          {errors.toDate && touched.toDate ? "Date Required" : null}
                        </div>
                      </FormGroup>
                    </Colxx>

                    <Colxx md="3">
                      <FormGroup className="form-group has-float-label mb-3">
                        <label>
                          <IntlMessages id="type" />
                        </label>
                        <FormikReactSelect
                          name="type"
                          id="type"
                          value={values.type}
                          options={typeOptions}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          placeholder=" "
                        />
                      </FormGroup>
                    </Colxx>

                    <Colxx md="3" className="text-end mt-2">
                      <Button type="submit" className="btn-sm me-2" color="primary" disabled={isSubmitting}>
                        {isSubmitting ? <FormLoader /> : <IntlMessages id="view" />}
                      </Button>
                      <Button type="button" className="btn-sm" color="secondary">
                        <IntlMessages id="cancel" />
                      </Button>
                    </Colxx>
                  </Row>
                </Form>
              )}
            </Formik>

            {/* Select All Checkbox and Download All Button */}
            {hasPermission(menuId, 'canPrint') && (
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center p-2 bg-light rounded">
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      id="selectAllCheckbox"
                      checked={
                        invoiceListData?.length > 0 &&
                        invoiceListData.every(row =>
                          selectedRows.includes(row.invoiceid)
                        )
                      }
                      onChange={handleSelectAll}
                      style={{ cursor: "pointer", width: "18px", height: "18px" }}
                    />
                    <label 
                      htmlFor="selectAllCheckbox" 
                      className="mb-0 ms-2" 
                      style={{ cursor: "pointer", fontWeight: "500" }}
                    >
                      Select All
                    </label>
                  </div>
                  
                  <Button 
                    color="success" 
                    size="sm" 
                    onClick={handleBulkDownload}
                    disabled={selectedRows.length === 0 || isBulkLoading}
                  >
                    {isBulkLoading ? <FormLoader /> : `Download (${selectedRows.length})`}
                  </Button>
                </div>
              </div>
            )}

            <div className="mt-2">
              <ServerMasterTable
                columns={cols}
                batchParam={manageDetailsParam}
                setBatchParam={setManageDetailsParam}
                data={invoiceListData?.length ? invoiceListData : []}
              />
            </div>
          </div>
        </div>
      </div>
      <Suspense>
        <ConfirmModal
          modalOpen={show}
          toggleModal={toggleModal}
          modalData={notificationData}
          performModalFunction={deleteData}
        />
      </Suspense>
    </>
  );
};

const mapStateToProps = (state) => ({
  customerslist: state.sim.adminuser,
  invoiceListData: state.report.invoiceListData,
  pdfData: state.report.pdfData,
  invoiceData: state.cardData.invoiceData,
  invoiceUpdateData: state.report.invoiceUpdateData
});

export default connect(mapStateToProps, {
  getDspUser1,
  viewInvoice,
  downloadInvoice,
  updateInvoice,
  clearInvoicePreview
})(CustomerInvoiceReport);